diy.angular.registerFactory('diyfmtracking', ['$rootScope', 'diyglobalevents', function($rootScope, diyglobalevents) {

    var currentSubsectionName = '';
    var lastSearchTerm = '';
    var lastSubsectionSearched = '';
    var eventsHandlerMap = {
            'searchCompleted': function(data) {
                var subsection = data.subsection;
                var subsectionTypeName = subsection.getTypeName();
                var searchTerm = subsection.getSearch();
                var searchEventName = 'diy-editor-filemanager-search';
                if (subsectionTypeName === 'companyPhotos'
                    || subsectionTypeName === 'recommendedCompanyPhotos'
                    || subsectionTypeName === 'cmsPhotos'
                    || subsectionTypeName === 'recommendedCmsPhotos'
                    || subsectionTypeName === 'bigstockPhotos'
                    || subsectionTypeName === '123rfPhotos'
                ) {
                    searchEventName += ((lastSearchTerm.length != 0)? 'repeated' : '');
                    diyglobalevents.trigger(searchEventName, {
                        searchPhrase: searchTerm,
                        totalResults: subsection.getItems().length
                    });
                    lastSearchTerm = searchTerm;
                    lastSubsectionSearched = subsectionTypeName;
                }
            },
            'subsectionChange': function(data) {
                var subsectionName = data.subsection.getTypeName()
                if (subsectionName !== currentSubsectionName) {
                    var sectionNameMap = {
                        'customerFiles': 'filemanager.myimages',
                        'recommendedCompanyPhotos': 'filemanager.topicRecommended',
                        'companyPhotos': 'filemanager.1and1_Images',
                        'recommendedCmsPhotos': 'filemanager.topicRecommended',
                        'cmsPhotos': 'filemanager.1and1_Images',
                        'bigstockPhotos': 'filemanager.Bigstock_Photos',
                        'bigstockPurchasedPhotos': 'filemanager.Bigstock_Purchased_Photos',
                        '123rfPhotos': 'filemanager.123rf_Photos',
                        '123rfPurchasedPhotos': 'filemanager.123rf_Purchased_Photos'
                    };
                    diyglobalevents.trigger('diy-editor-generic-sectionAccessed', {
                        sectionCodeName: sectionNameMap[subsectionName]
                    });
                    currentSubsectionName = subsectionName;
                }
            },
            'addToInsertion': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-addInsertion', {
                    count: data.items.length,
                    source: data.source,
                    section: data.subsection.getTypeName(),
                    currentSearch: data.subsection.getSearch()
                });
            },
            'clearAllInserted': function() {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'clearAllInserted'
                });
            },
            'uploadedFiles': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-uploadedFiles', {
                    count: data.uploadedItems.length,
                    source: data.source
                });
            },
            'uploadButtonClick': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-uploadButtonClick');
            },
            'bigstockLimit': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-bigstockLimit');
            },
            'jumpToBigstock': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'jumpToBigstock',
                    pageName: 'Bigstock Limit'
                });
            },
            'cancelJumpToBigstock': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'close',
                    pageName: 'Bigstock Limit'
                });
            },
            '123RFLimit': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-123RFLimit');
            },
            'jumpTo123RF': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'jumpToBigstock',
                    pageName: '123RF Limit'
                });
            },
            'cancelJumpTo123RF': function(data) {
                diyglobalevents.trigger('diy-editor-generic-linkInteraction', {
                    actionName: 'close',
                    pageName: '123RF Limit'
                });
            },
            'deleteFilesClicked': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-deleteFilesClicked', {
                    count: data.itemsCount
                });
            },
            'createdFolder': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-createdFolder');
            },
            'deletedFolder': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-deletedFolder');
            },
            'insertedItems': function(data) {
                diyglobalevents.trigger('diy-editor-filemanager-insertedFiles', {
                    count: data.items.length
                });
            },
            'newSearch': function (data) {
                diyglobalevents.trigger('diy-editor-filemanager-newSearch', {
                    searchTerms: data.search
                });
            }
    };

    for (var eventName in eventsHandlerMap) {
        if (eventsHandlerMap.hasOwnProperty(eventName)) {
            $rootScope.$on(eventName, function(ev, data) {
                eventsHandlerMap[ev.name](data);
            });
        }
    }

    return {
        track: function(eventName, data) {
            if (eventsHandlerMap.hasOwnProperty(eventName)) {
                eventsHandlerMap[eventName](data);
            }
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmtracking.js
 ** module id = 945
 ** module chunks = 0
 **/